import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import FilterContainer from '../../../../Tracking/components/NFFilters/components/FilterContainer';
import FilterForm from '../../../../Tracking/components/NFFilters/components/FilterForm';
import { Container } from '../../../styles';
import { DATE_FILTERS, dateFilterToDays } from '../../Filter/RetrofitDateModal';
import { FormLabelStyled, LabelStyled, RadioGroupStyled, RadioStyled } from '../../Filter/RetrofitDateModal/styles';

const normalizeByDateType = value => Number(value ?? dateFilterToDays.BY_ISSUE_DATE);

const ViewType = ({ isOpen, onClick, onApply, byDate, value }) => {
  const [selectedItem, setSelectedItem] = useState(() => normalizeByDateType(byDate));

  useEffect(() => {
    if (!isOpen) return;

    setSelectedItem(normalizeByDateType(byDate));
  }, [isOpen, byDate]);

  const handleChangeByDate = e => {
    setSelectedItem(Number(e.target.value));
  };

  const handleSubmit = e => {
    e.preventDefault();
    const normalized = normalizeByDateType(selectedItem);
    const displayValue =
      normalized === dateFilterToDays.BY_ISSUE_DATE
        ? DATE_FILTERS.BY_ISSUE_DATE
        : DATE_FILTERS.BY_DELIVERY_DATE;
    onApply({ byDate: normalized, displayValue });
  };

  const clearFilter = () => {

    setSelectedItem(dateFilterToDays.BY_ISSUE_DATE);
    onApply({ byDate: dateFilterToDays.BY_ISSUE_DATE, displayValue: '' });
  };

  return (
    <FilterContainer label="Tipo de visualização" isOpen={isOpen} onClick={onClick} value={value}>
      <FilterForm
        label="Filtrar por tipo de visualização"
        onSubmit={handleSubmit}
        clearFilter={clearFilter}
      >
        <Container>
          <RadioGroupStyled
            value={selectedItem}
            onChange={handleChangeByDate}
          >
            <FormLabelStyled
              value={dateFilterToDays.BY_ISSUE_DATE}
              control={<RadioStyled />}
              label={
                <LabelStyled component="span">
                  {DATE_FILTERS.BY_ISSUE_DATE}
                </LabelStyled>
              }
            />
            <FormLabelStyled
              value={dateFilterToDays.BY_DELIVERY_DATE}
              control={<RadioStyled />}
              label={
                <LabelStyled component="span">
                  {DATE_FILTERS.BY_DELIVERY_DATE}
                </LabelStyled>
              }
            />
          </RadioGroupStyled>
        </Container>
      </FilterForm>
    </FilterContainer>
  );
};

const mapStateToProps = (state) => ({
  byDate: state.dashboardFilters.filters.byDate
});

export default connect(mapStateToProps)(ViewType);
